import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import marketingSmall from '@icons/marketingSmall';
import salesSmall from '@icons/salesSmall';
import salesIntSmall from '@icons/salesIntSmall';
import webVisitorSmall from '@icons/webVisitorSmall';
import b2bAddSmall from '@icons/b2bAddSmall';
import Capabilities from '../../ctas/Capabilities';
import LatestResourcesCTA from '../../ctas/LatestResources';
import BookACallCTA from '../../ctas/BookACall';

export const Solutions = () => {
  const { t } = useTranslation();
  return {
    label: t('nav_label_use_cases'),
    submenus: [
      {
        label: t('nav_by_team'),
        columns: 1,
        subgroups: [
          {
            label: t('nav_solutions_marketing'),
            href: '/solutions/marketing',
            caption: t('nav_solutions_marketing_caption'),
            icon: marketingSmall,
            grid: true,
          },
          {
            label: t('nav_solutions_sales'),
            href: '/solutions/sales',
            caption: t('nav_solutions_sales_caption'),
            icon: salesSmall,
            grid: true,
          },
        ],
      },
      {
        label: t('nav_by_use'),
        columns: 2,
        subgroups: [
          {
            label: t('nav_label_target_icp_fit_leads'),
            href: '/solutions/marketing/target-icp-leads',
            caption: t('nav_label_target_icp_fit_leads_caption'),
            icon: b2bAddSmall,
            grid: true,
          },
          {
            label: t('nav_sales_advertising_page'),
            href: '/solutions/b2b-advertising',
            caption: t('nav_sales_advertising_page_caption'),
            icon: b2bAddSmall,
            grid: true,
          },
          {
            label: t('nav_label_prioritize_top_accounts'),
            href: '/solutions/marketing/prioritize-top-accounts',
            caption: t('nav_label_prioritize_top_accounts_caption'),
            icon: b2bAddSmall,
            grid: true,
          },
          {
            label: '',
            href: '/',
            caption: '',
            grid: true,
            spacer: true,
            mobOrder: 7,
          },
          {
            label: t('nav_label_sales_prospecting_page'),
            href: '/solutions/sales-prospecting',
            caption: t('nav_label_sales_prospecting_page_caption'),
            icon: salesIntSmall,
            grid: true,
          },
          {
            label: '',
            href: '/',
            caption: '',
            grid: true,
            spacer: true,
            mobOrder: 7,
          },
          {
            label: t('nav_webvisitors_ident'),
            href: '/solutions/web-visitor-tracking',
            caption: t('nav_webvisitors_ident_caption'),
            icon: webVisitorSmall,
            grid: true,
          },
          {
            label: '',
            href: '/',
            caption: '',
            grid: true,
            spacer: true,
            mobOrder: 7,
          },
        ],
      },
    ],
    ctas: [
      {
        columns: 1,
        label: 'Playbooks',
        content: (
          <>
            <LatestResourcesCTA />
            <div className="view-all-links">
              <a
                className="icon-link icon-link--dark icon-link-- view-all-resources"
                target="_self"
                hrefLang="en"
                href="/resources/playbooks/"
              >
                View all Playbooks
                <svg
                  className="icon-link__chevron"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="20"
                    height="20"
                    rx="10"
                    fill="currentColor"
                  ></rect>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z"
                    fill="white"
                  ></path>
                </svg>
              </a>
            </div>
          </>
        ),
      },
      {
        label: 'Capabilities',
        content: (
          <>
            <Capabilities newCap={true} />
            <div className={'hr-line'}></div>
            <BookACallCTA />
          </>
        ),
        columns: 1,
      },
    ],
  };
};